export const ConfigMantenedorGuiaDespacho = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Cliente", "Folio", "Track Id"],
		criteriosKeys: ["razonSocialReceptor", "rutReceptor", "folio", "trackId"],
		criterioPrincipal: "Razon Social",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Guias Emitidas",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
